import React from 'react';
import RecipientsSearchBar from './RecipientSearchBar';

const emailTabs = ['Email', 'Performance', 'Recipients'];

function EmailPerformanceTabs({ activeTab, setActiveTab, searchValue, setSearchValue }) {
  return (
    <div className='email-tabs-container-recipients'>
      <div className='email-tabs-container-performance'>
        {emailTabs.map((tab, index) => {
          return (
            <div
              key={`${tab}-${index}`}
              data-testid={`email-tab-${tab.toLowerCase()}`}
              className={`email-tab-btn rounded-pill ${activeTab === tab ? 'email-tab-btn-active' : ''}`}
              onClick={() => {
                setActiveTab(tab);
              }}
            >
              {tab}
            </div>
          );
        })}
      </div>
      {activeTab === 'Recipients' && <RecipientsSearchBar searchValue={searchValue} setSearchValue={setSearchValue} />}
    </div>
  );
}

export default EmailPerformanceTabs;
